export default "__VITE_ASSET__40ce3789__"